import _objectSpread from '@babel/runtime/helpers/esm/objectSpread2';
import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import { useState, useCallback, useMemo } from 'react';

function useModalTrigger() {
  var _useState = useState({
    isOpen: false,
    value: null
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var open = useCallback(function () {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    return setState({
      value: value,
      isOpen: true
    });
  }, []);
  var close = useCallback(function () {
    return setState(function (s) {
      return _objectSpread(_objectSpread({}, s), {}, {
        isOpen: false
      });
    });
  }, []);
  var toggle = useCallback(function () {
    return setState(function (s) {
      return _objectSpread(_objectSpread({}, s), {}, {
        isOpen: !s.isOpen
      });
    });
  }, []);
  var onClosed = useCallback(function () {
    return setState(function (s) {
      return {
        value: null,
        isOpen: false
      };
    });
  }, []);
  var memoActions = useMemo(function () {
    return {
      open: open,
      toggle: toggle,
      close: close,
      onClosed: onClosed
    };
  }, [open, toggle, close, onClosed]);
  return [state, memoActions];
}

export default useModalTrigger;
